export default "__VITE_ASSET__BppzmyJ5__"